import React, { Component } from 'react';
import { Icon, Button } from 'antd';

class InfoWallet extends Component {
	render() {
		return (
			<div style={{ textAlign: 'center' }}>
				<Icon type="check-circle" style={{ fontSize: '44px' }} />
				<h2>Success</h2>
				<Button onClick={this.props.onOk} type="primary" block>
					Done
				</Button>
			</div>
		);
	}
}

export default InfoWallet;
